import styled from 'styled-components'
import Note from 'components/Note'

const getDisplay = props => !(props.children.length && props.children[0]) && 'none'

const WimeNote = styled(Note)`
  font-weight: 500;
  display: ${getDisplay};
`

export default WimeNote
